import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import { Box, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Demand from '../../../Models/CreateAgence';
import formatDate from "../../../Functions/Traitement/fomatDate";
import CheckStan from "../../Prints/CheckStan";
import RadioBox from "../../Radiox";
import AgenceConfigDialog from "./AgenceConfigDialog"; // ← import du dialogue

// Paramètres de recherche
let searchAgence: ParamsPicklist = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchVille: ParamsPicklist = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '101', Choix: 22 }
let searchComptes: ParamsPicklist = { CodeAgence: '', Table: "Comptes", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegion: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre: "RUBRIQ", valfiltre: 'REGION', Choix: 22 }

const Agence = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [isConfigured, setIsConfigured] = useState(false);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Liblibelle, setLiblibelle] = useState(true);
    const [isAjoutMode, setIsAjoutMode] = useState(false);

    // ← Nouvel état pour le dialogue de configuration
    const [configDialogOpen, setConfigDialogOpen] = useState(false);

    const dataOption2: DataSelect[] = [
        { label: "Simple", value: "1" },
        { label: "Moyen", value: "2" },
        { label: "Complet", value: "3" }
    ]

    const dataOption1: DataSelect[] = [
        { label: "ANNUELLE", value: "ANNUELLE" },
        { label: "SEMESTRIELLE", value: "SEMESTRIELLE" },
        { label: "TRIMESTRIELLE", value: "TRIMESTRIELLE" },
        { label: "BIMENSUELLE", value: "BIMENSUELLE" },
        { label: "JOURNALIERE", value: "JOURNALIERE" },
        { label: "BIMESTRIELLE", value: "BIMESTRIELLE" },
        { label: "HEBDOMADAIRE", value: "HEBDOMADAIRE" },
        { label: "MENSUELLE", value: "MENSUELLE" }
    ]

    // Handle functions
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        setIdbutton(true);
        setLiblibelle(true);
        setIsAjoutMode(false);
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdbutton(false);
        setLiblibelle(false);
        setIsAjoutMode(true);
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('modif');
        setSupprime(true);
        setIdbutton(true);
        setLiblibelle(false);
        setIsAjoutMode(false);
    }

    function HandleSupp() {
        setSbmit('supp');
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdbutton(false);
        setLiblibelle(true);
        setIsAjoutMode(false);
        setIsConfigured(false); // reset isConfigured à l'annulation
    }

    /**
     * Ouvre le dialogue de configuration si l'agence n'est pas encore configurée.
     * Le bouton est disabled quand isConfigured === true (déjà configurée).
     */
    function HandleConfigure() {
        const codeAgence = form.getFieldValue("CODAGE");
        if (!codeAgence) {
            SweetAlert.fire({ title: "Svp consultez d'abord une agence", icon: "warning" });
            return;
        }
        if (isConfigured) {
            SweetAlert.fire({ title: "Cette agence est déjà configurée", icon: "info" });
            return;
        }
        setConfigDialogOpen(true);
    }

    // ─── ONGLETS ────────────────────────────────────────────────────────────────
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (<span id='x'><UserOutlined /> Panel 1</span>),
            children: (
                <div className='tabItem'>
                    <div style={{ display: 'block flow' }}>
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
                            <legend>Création Agence</legend>

                            {/* ── Section 1 : Identification & Localisation ── */}
                            <fieldset className="bordure1" style={{ marginTop: -15 }}>
                                <legend style={{ fontSize: 12, color: '#555' }}>Identification &amp; Localisation</legend>
                                <Box style={{ display: 'flex', gap: 16 }}>
                                    <Box style={{ flex: 1 }}>
                                        <Box style={{ marginTop: -7 }}>
                                            <SearInputG width={6} dissabledLib={Liblibelle} dissabledCode={Idbutton} notRequired Titre=" Recherche" label='Code Agence' notremove name="CODAGE" Taille1={'100%'} Taille2={'100%'} Parametre={searchAgence} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={6} Titre="" notRequired label="AGC Rattachée" name="Agcelocal" Parametre={searchAgence} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={6} Titre="" notRequired label="Région" name="codRegion" Parametre={searchRegion} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={6} Titre="" notRequired label="Code Ville" name="cdville" Parametre={searchVille} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -12 }}>
                                            <InputForm width={6} label="Licence" type="text" name="LICENCE" />
                                        </Box>
                                        
                                    </Box>

                                    <Box style={{ flex: 1 }}>
                                        <Box style={{ marginTop: -7 }}>
                                            <InputForm width={5} label="Boite Postale" type="number" name="BPOSTE" />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={7} label="Téléphone" type="number" name="TELEPH" />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={0} label="Fax" type="number" name="NUMFAX" />
                                        </Box>
                                        {/* <Box style={{ marginTop: -10 }}>
                                            <InputForm width={13} label="Nbre Jours Date Valeur Chèque" type="number" name="nbjrValChq" />
                                        </Box> */}
                                        <Form.Item style={{ width: '100%', marginTop: -10, marginBottom: -12 }}>
                                            <SelectOption Option={dataOption1} width={10} label="Fréquence" Size={'100%'} name="frequence" />
                                        </Form.Item>
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={6} label="Coopérative" type="text" name="BANQUE" />
                                        </Box>
                                    </Box>
                                </Box>
                            </fieldset>

                            {/* ── Section 2 : Compte (grisée en mode Ajout) ── */}
                            <fieldset
                                className="bordure1"
                                style={{ marginTop: 8, opacity: isAjoutMode ? 0.5 : 1, pointerEvents: isAjoutMode ? 'none' : 'auto', background: isAjoutMode ? '#f5f5f5' : 'inherit' }}
                                disabled={isAjoutMode}
                            >
                                <legend style={{ fontSize: 12, color: '#555' }}>Comptes</legend>
                                <Box style={{ marginBottom: 4 }}>
                                    <Typography variant="caption" style={{ color: '#888', fontStyle: 'italic' }}>
                                        Compte généré automatiquement sur la base de l'agence de rattachement
                                    </Typography>
                                </Box>
                                <Box style={{ display: 'flex', gap: 16 }}>
                                    <Box style={{ flex: 1 }}>
                                        <Box style={{ marginTop: -7 }}>
                                            <SearchModal width={10} Titre="" notRequired label="Compte Mise à Disposition" name="cptmad" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={6} Titre="" notRequired label="Compte Résultat" name="cptresult" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" notRequired label="Idplan Chèque Escompté" name="IdPlanChqEscompClt" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" notRequired label="Idplan Chèque Encaissement Client" name="IdPlanChqEncaiClt" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </Box>

                                    <Box style={{ flex: 1 }}>
                                        <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: -7 }}>
                                            <Box style={{ flex: 3 }}>
                                                <SearchModal width={10} Titre="" notRequired label="Compte TVA Collectée" name="cpttva1" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ flex: 1, marginTop: -10 }}>
                                                <InputForm width={0} notRequired label="Taux" type="number" money name="TauxTVA" />
                                            </Box>
                                        </Box>
                                        <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: -10 }}>
                                            <Box style={{ flex: 3 }}>
                                                <SearchModal width={10} Titre="" notRequired label="Compte TVA à Recevoir" name="cpttva2" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ flex: 1, marginTop: -10 }}>
                                                <InputForm width={0} label="Taux" notRequired type="number" money name="tauxtva2" />
                                            </Box>
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" notRequired label="Compte Liaison Opérations Débits" name="cptLiaiOpDebit" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={10} Titre="" notRequired label="Compte Liaison Opérations Crédits" name="cptLiaiOpCredit" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </Box>
                                </Box>
                            </fieldset>

                            {/* ── Section 3 : Paramètres de Sécurité & Valeur Date ── */}
                            <fieldset className="bordure1" style={{ marginTop: 8 }}>
                                <legend style={{ fontSize: 12, color: '#555' }}>Paramètres de Sécurité &amp; Date Valeur</legend>
                                <Box style={{ display: 'flex', gap: 16, marginTop: -5 }}>
                                    <Box style={{ flex: 1 }}>
                                        <Box style={{ marginTop: 0 }}>
                                            <InputForm width={14} label="Mot de Passe Expire Après (jours)" type="number" name="expire" />
                                        </Box>
                                        
                                        {/* <Box style={{ marginTop: -10 }}>
                                            <InputForm width={0} label="Montant Max Déclaré" type="number" name="mtnMaxDeclar" />
                                        </Box> */}
                                        {/* <Box style={{ marginTop: -10 }}>
                                            <InputForm width={0} label="Montant Min Déclaré" type="number" name="mtnMinDeclar" />
                                        </Box> */}
                                    </Box>
                                    <Box style={{ flex: 1 }}>
                                        {/* <Box style={{ marginTop: 12, marginBottom: -35, marginLeft: 19 }}>
                                            <CheckStan width={18} label={"Clé de Compte Numérique"} name={"ISKEYCPTNUMERIC"} />
                                        </Box> */}
                                        {/* <Box style={{ marginTop: -10, marginBottom: -35, marginLeft: 19 }}>
                                            <CheckStan width={18} label={"Agence Principale ?"} name={"ISAGCEPRINCIPAL"} />
                                        </Box> */}
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={14} label="Nbre Tentative de Connexion" type="number" name="nbrtentative" />
                                        </Box>
                                    </Box>
                                    <Box style={{ flex: 1 }}>
                                        {/* <Box style={{ marginTop: 0 }}>
                                            <InputForm width={0} label="Jour Compte Courant Débit" type="texte" name="PARVALD" />
                                        </Box> */}
                                        {/* <Box style={{ marginTop: -10 }}>
                                            <InputForm width={0} label="Jour Compte Courant Crédit" type="texte" name="PARVALI" />
                                        </Box> */}
                                        {/* <Box style={{ marginTop: -10 }}>
                                            <InputForm width={0} label="Jour Compte Épargne Débit" type="texte" name="PAREPD" />
                                        </Box> */}
                                        {/* <Box style={{ marginTop: -10 }}>
                                            <InputForm width={0} label="Jour Compte Épargne Crédit" type="texte" name="PAREPC" />
                                        </Box> */}
                                    </Box>
                                </Box>
                            </fieldset>

                            {/* ── Section 4 : Messages Publicitaires ── */}
                            <fieldset className="bordure1" style={{ marginTop: 8 }}>
                                <legend style={{ fontSize: 12, color: '#555' }}>Messages Publicitaires</legend>
                                <Box style={{ marginTop: -10, width: '80%' }}>
                                    <InputForm width={0} label="Pub 1" type="text" name="PUBLI1" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '80%' }}>
                                    <InputForm width={0} label="Pub 2" type="text" name="PUBLI2" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '80%' }}>
                                    <InputForm width={0} label="Message Publicitaire" type="text" name="MSGPUBNETSOFT" />
                                </Box>
                            </fieldset>
                        </Box>
                    </div>
                </div>
            ),
        },
        {
            key: '2',
            label: (<span id='x'><UserOutlined /> Panel 2</span>),
            children: (
                <div className='tabItem'>
                    <div style={{ display: 'block flow' }}>
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
                            <legend>Création Agence</legend>
                            <Box style={{ display: 'flex', marginTop: -15, gap: 8 }}>

                                {/* ── Colonne 1 ── */}
                                <fieldset className="bordure1">
                                    <legend style={{ fontSize: 12, color: '#555' }}>Gestion Prêts &amp; Agios</legend>
                                    <Box>
                                        <Box style={{ marginTop: 5, marginBottom: -35, paddingLeft: 13 }}>
                                            <CheckStan width={21} label={"Gestion des Remboursements Partiels"} name={"GESPRETDETAIL"} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <InputForm width={15} label="Remboursement Partiel Limité à" type="number" name="NBRJRFIXREMB" taille={160} />
                                        </Box>
                                        <Form.Item style={{ width: '100%', marginTop: -13, marginBottom: -12 }}>
                                            <SelectOption Option={dataOption2} width={15} label="Schéma Traitement Chèque" Size={'100%'} name="STRAITCHQ" />
                                        </Form.Item>
                                        <br /><br />
                                        {/* <Box>
                                            <CheckStan width={21} label={"Choisir le type d'intérêt/Commission lors du calcul des agios"} name={"ISCHOSEINT"} />
                                        </Box> */}
                                        <Box style={{ marginTop: -30 }}>
                                            <CheckStan width={21} label={"Gestion Auto des écritures liées au manquant ou excédent"} name={"GESAUTOERCAI"} />
                                        </Box>
                                        {/* <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Calcul Agios Compte Ouverts 1ère Quinzaine"} name={"iscalfirsweek"} />
                                        </Box> */}
                                        {/* <Box>
                                            <CheckStan width={21} label={"Calcul Agios Compte Ouverts 2ème Quinzaine"} name={"iscalsweek"} />
                                        </Box> */}
                                        {/* <Box style={{ marginTop: -30 }}>
                                            <CheckStan width={21} label={"Modifier le Type d'intérêt et Commission Dans Contrôle de Cpte"} name={"iseditintcom"} />
                                        </Box> */}
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Ne pas Confirmer les litiges à la Caisse ?"} name={"isnotconfcai"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Samedi Ouvrable ?"} name={"SAMEDI"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Dimanche Ouvrable ?"} name={"DIMANCHE"} />
                                        </Box>
                                    </Box>
                                </fieldset>

                                {/* ── Colonne 2 ── */}
                                <fieldset className="bordure1">
                                    <legend style={{ fontSize: 12, color: '#555' }}>Caisse &amp; Opérations</legend>
                                    <Box>
                                        <Box>
                                            <CheckStan width={21} label={"Système Arrêt Caisse"} name={"ARRETCAIS"} />
                                        </Box>
                                        <Box style={{ marginTop: -30 }}>
                                            <CheckStan width={21} label={"Voir Encaisse Informatique"} name={"ENCINF"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Gestion Automatique des Erreurs"} name={"GESAUTOERCAI"} />
                                        </Box>
                                        <Box>
                                            <CheckStan width={21} label={"Coloriser le Formulaire Billetage des Caisses"} name={"ISCASHCOLOR"} />
                                        </Box>
                                        <Box style={{ marginTop: -30 }}>
                                            <CheckStan width={21} label={"Manquant et Excédent Limité à la Caisse ?"} name={"ismanqlim"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Validations des Opérations En Back-Office"} name={"isvalidinbo"} />
                                        </Box>
                                        <Box>
                                            <CheckStan width={21} label={"Validation des Impayés"} name={"IMPAYE"} />
                                        </Box>
                                    </Box>
                                </fieldset>

                                {/* ── Colonne 3 ── */}
                                <fieldset className="bordure1">
                                    <legend style={{ fontSize: 12, color: '#555' }}>Commissions &amp; Comptes Clients</legend>
                                    <Box>
                                        <Box>
                                            <CheckStan width={21} label={"Commission sur Retrait en Compte Épargne"} name={"isComRetEpar"} />
                                        </Box>
                                        <Box style={{ marginTop: -30 }}>
                                            <CheckStan width={21} label={"Commission sur Retraits Avec Chèque Guichet"} name={"iscomChqGuich"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Validation des Comptes"} name={"IsValidCpte"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Autoriser Multiple Litige Sur Compte ?"} name={"isMultiLitige"} />
                                        </Box>
                                        <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                            <CheckStan width={21} label={"Modifier Nom du Compte ?"} name={"isModifNomCpt"} />
                                        </Box>
                                        {/* <Box style={{ marginTop: -30 }}>
                                            <CheckStan width={21} label={"Validation Prêt : Utilisateur Différent ?"} name={"isUtivalDiffUtisaiPret"} />
                                        </Box> */}
                                    </Box>
                                </fieldset>
                            </Box>
                        </Box>
                    </div>
                </div>
            ),
        }
    ];

    // ─── FONCTIONS API ───────────────────────────────────────────────────────────
    function consult() {
        if (form.getFieldValue("CODAGE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le Code Agence", icon: "warning" });
        } else {
            HandleConsult();
            let data = form.getFieldValue("CODAGE");
            if (data.length !== 0) {
                setLoading(true);
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadAgence,
                    headers: { 'CypherAgence': data, 'Authorization': authHeader(), 'Content-Type': 'application/json' },
                };
                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            let DemandVP = res.Result.Table[0];
                            if (res.StatutCode === 200) {
                                if (DemandVP.messag === "Inexiste") {
                                    HandleAnnul();
                                    SweetAlert.fire({ title: "", text: "Code Agence Inexistant", icon: "warning" });
                                } else {
                                    setIsConfigured(DemandVP.isConfigured);
                                    form.setFieldsValue(DemandVP);
                                    form.setFieldValue("lib_CODAGE", DemandVP.LIBELLE);
                                    form.setFieldValue("lib_Agcelocal", DemandVP.LibAgceRattache);
                                    form.setFieldValue("lib_codRegion", DemandVP.LibRegion);
                                    form.setFieldValue("lib_cptmad", DemandVP.LibCptMAD);
                                    form.setFieldValue("lib_cptresult", DemandVP.LibCptResult);
                                    form.setFieldValue("lib_cpttva1", DemandVP.LibCptTvaDeductible);
                                    form.setFieldValue("lib_cpttva2", DemandVP.LibCptTvaCollecte);
                                    form.setFieldValue("lib_cptLiaiOpDebit", DemandVP.LibCptLiaidebit);
                                    form.setFieldValue("lib_cptLiaiOpCredit", DemandVP.LibCptLiaiCredit);
                                    form.setFieldValue("lib_cdville", DemandVP.LibVille);
                                    form.setFieldValue("lib_IdPlanChqEncaiClt", DemandVP.LibIdChqEncClt);
                                    form.setFieldValue("lib_IdPlanChqEscompClt", DemandVP.LibIdChqEsomptClt);
                                }
                            } else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                            }
                        }
                    })
                    .catch((error) => {
                        setLoading(false);
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" });
                    });
            }
        }
    }

    const onFinish = (values: any) => {
        var demand: Demand = values;
        demand.UTILIS = Perss.coduti;
        demand.DATCRE = formatDate(Perss.datjour);
        demand.DATMODIF = formatDate(Perss.datjour);
        demand.LIBELLE = form.getFieldValue("lib_CODAGE");
        demand.WAITIN1 = formatDate(Perss.datjour);
        demand.WAITIN = formatDate(Perss.datjour);

        if (sbmit === "add") {
            SweetAlert.fire({
                title: "Création d'une Agence",
                text: "Voulez-vous créer l'Agence : " + form.getFieldValue("lib_CODAGE"),
                showCancelButton: true, confirmButtonText: "Yes", confirmButtonColor: "#116599",
                cancelButtonColor: "darkred", cancelButtonText: "No", icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true); setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(demand));
                    axios.request({ method: 'post', url: Data.ApiUrl.CreateAgence, headers: { 'CypherAgence': data, 'Authorization': authHeader(), 'Content-Type': 'application/json' } })
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode === 200) {
                                    if (res.Result === 'Existe') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déjà, svp choisissez un autre", icon: "warning" });
                                    } else { HandleAnnul(); SweetAlert.fire({ title: res.Message, text: "Code : " + res.Result, icon: "success" }); }
                                } else { SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" }); }
                            }
                        }).catch((error) => { setLoading(false); SweetAlert.fire({ title: "Error", text: error, icon: "error" }); });
                }
            });
        }

        if (sbmit === "modif") {
            SweetAlert.fire({
                title: "Mise à Jour d'une Agence",
                text: "Voulez-vous mettre à jour l'Agence : " + form.getFieldValue("lib_CODAGE"),
                showCancelButton: true, confirmButtonText: "Yes", confirmButtonColor: "#116599",
                cancelButtonColor: "darkred", cancelButtonText: "No", icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true); setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(demand));
                    axios.request({ method: 'put', url: Data.ApiUrl.UpdateAgence, headers: { 'CypherAgence': data, 'Authorization': authHeader(), 'Content-Type': 'application/json' }, data })
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode === 200) {
                                    if (res.Result === 'INCONNU') { SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" }); }
                                    else { HandleAnnul(); SweetAlert.fire({ title: res.Message, text: "Code : " + res.Result, icon: "success" }); }
                                } else { SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" }); }
                            }
                        }).catch((error) => { setLoading(false); SweetAlert.fire({ title: "Error", text: error, icon: "error" }); });
                }
            });
        }

        if (sbmit === "supp") {
            SweetAlert.fire({
                title: "Suppression d'une Agence",
                text: "Voulez-vous supprimer l'Agence : " + form.getFieldValue("lib_CODAGE"),
                showCancelButton: true, confirmButtonText: "Yes", confirmButtonColor: "#116599",
                cancelButtonColor: "darkred", cancelButtonText: "No", icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true); setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(demand.CODAGE));
                    axios.request({ method: 'delete', url: Data.ApiUrl.DeleteAgence, headers: { 'CypherAgence': data, 'Authorization': authHeader(), 'Content-Type': 'application/json' }, data })
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode === 200) {
                                    if (res.Result === 'INCONNU') { SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" }); }
                                    else { HandleAnnul(); SweetAlert.fire({ title: res.Message, text: "Code : " + res.Result, icon: "success" }); }
                                } else { SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" }); }
                            }
                        }).catch((error) => { setLoading(false); SweetAlert.fire({ title: "Error", text: error, icon: "error" }); });
                }
            });
        }
    };

    const onFinishFailed = (errorInfo: any) => {
        let errors: any = [];
        errorInfo.errorFields.map((error: any) => errors.push(error.name + ""));
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' });
    };

    // ─── RENDU ───────────────────────────────────────────────────────────────────
    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={consult} type="ghost" htmlType="button" block>Consulter</Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={HandleAjout} type="ghost" htmlType="button" block>Ajouter</Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={HandleModif} type="ghost" htmlType="button" block>Modifier</Button>
                                {/*
                                  Bouton Configurer :
                                  - disabled si isConfigured === true (déjà configurée)
                                  - disabled si aucune agence n'est consultée (Modifactv sert de proxy)
                                */}
                                <Button
                                    size='large'
                                    className='bt_add'
                                    disabled={isConfigured || Modifactv}
                                    onClick={HandleConfigure}
                                    type="ghost"
                                    htmlType="button"
                                    block
                                    title={isConfigured ? "Agence déjà configurée" : "Configurer les comptes et dates comptables"}
                                >
                                    Configurer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>Enregistrer</Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={HandleSupp} type="ghost" htmlType="submit" block>Supprimer</Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => form.resetFields()} type="ghost" htmlType="button" block>Actualiser</Button>
                                <Button size='large' disabled={Annulactv} onClick={HandleAnnul} className='bt_add' type="ghost" htmlType="reset" block>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                    </div>
                </Form>
            </Spin>

            {/* ── Dialogue de configuration ── */}
            <AgenceConfigDialog
                open={configDialogOpen}
                onClose={() => setConfigDialogOpen(false)}
                codeAgence={form.getFieldValue("CODAGE") ?? ""}
                libelleAgence={form.getFieldValue("lib_CODAGE") ?? ""}
                agenceRattachement={form.getFieldValue("Agcelocal") ?? ""}
                libelleRattachement={form.getFieldValue("lib_Agcelocal") ?? ""}
                authHeader={authHeader()}
                createBy={Perss.coduti}
                datJour={Perss.datjour}
                onConfigured={() => {
                    // Marquer l'agence comme configurée et désactiver le bouton
                    setIsConfigured(true);
                    SweetAlert.fire({
                        title: "Configuration réussie",
                        text: `L'agence ${form.getFieldValue("CODAGE")} est maintenant configurée.`,
                        icon: "success",
                    });
                }}
            />
        </div>
    );
};

export default Agence;